import React, { forwardRef, ReactNode } from 'react';
import {
  FormControl as ChakraFormControl,
  FormControlProps,
} from '@chakra-ui/react';

interface Props extends Omit<FormControlProps, `css`> {
  children: ReactNode;
}

export const FormControl = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraFormControl ref={ref} {...props}>
        {children}
      </ChakraFormControl>
    );
  }
);

export type { Props as FormControlProps };
